import { getSite } from '../../../provolution/jsCore/application/pageDataObject'

function getCookie(name) {
  let re = new RegExp(name + '=([^;]+)')
  let value = re.exec(document.cookie)
  return value !== null ? unescape(value[1]) : null
}

export function trackGoogleAnalyticsSessionId() {
  if (getSite() !== 'ei') {
    var id = getCookie('ga')
    if (undefined !== id && id !== null && id.length > 2) {
      window.experimentId = parseInt(id.substring(id.length - 2, id.length))
    }
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/googleAnalyticaSessionTracker/googleAnalyticaSessionTracker.js